// @flow
import * as React from "react";
import { pathOr, propEq } from "ramda";

type FilterOption = {
  displayKey: string,
  displayName: string,
  test: (any, any) => boolean,
};

type Props = {
  defaultOption: $PropertyType<FilterOption, "displayKey">,
  filterChangedCallback: Function,
  filterOptions: Array<FilterOption>,
  valueGetter: Function,
};

type State = {
  filter: string,
  option: $PropertyType<FilterOption, "displayKey">,
};

type AgGridFilterModel = {
  filter: string,
  type: $PropertyType<FilterOption, "displayKey">,
  filterType: "formattedNumber",
};

export default class FormattedNumberFilter extends React.Component<
  Props,
  State
> {
  input: ?HTMLInputElement;

  static defaultProps = {
    filterOptions: [
      {
        displayKey: "equals",
        displayName: "Igual",
        test: (filterValue: any, cellValue: any) => filterValue === cellValue,
      },
    ],
  };

  state = {
    filter: "",
    option:
      this.props.defaultOption ||
      pathOr("equals", ["filterOptions", 0, "displayKey"], this.props),
  };

  isFilterActive() {
    return this.state.filter != null && this.state.filter !== "";
  }

  doesFilterPass(params: *) {
    const filter = this.props.filterOptions.find(
      propEq("displayKey", this.state.option)
    );
    return filter
      ? filter.test(this.state.filter, this.props.valueGetter(params.node))
      : true;
  }

  getModel(): AgGridFilterModel {
    return {
      filter: this.state.filter,
      filterType: "formattedNumber",
      type: this.state.option,
    };
  }

  setModel(model: AgGridFilterModel) {
    const filter = model ? model.filter : "";
    const option = model ? model.type : "equals";
    this.setState({ filter, option });
  }

  afterGuiAttached() {
    this.focus();
  }

  focus() {
    window.setTimeout(() => {
      if (this.input && this.input.focus) this.input.focus();
    });
  }

  onFloatingFilterChanged = ({ filter = "" }: AgGridFilterModel) => {
    if (this.state.filter !== filter) {
      this.setState({ filter }, () => {
        this.props.filterChangedCallback();
      });
    }
  };

  onChange = (event: *) => {
    const newValue = event.target.value;
    if (this.state.filter !== newValue) {
      this.setState({ filter: newValue }, () => {
        this.props.filterChangedCallback();
      });
    }
  };

  onChangeOption = (event: *) => {
    this.setState({ option: event.target.value }, () => {
      this.props.filterChangedCallback();
    });
  };

  render() {
    const { filterOptions: options } = this.props;

    return (
      <div className="ag-filter-body-wrapper">
        {options.length > 0 && (
          <select
            className="ag-filter-select"
            value={this.state.option}
            onChange={this.onChangeOption}
            disabled={options.length < 2}
          >
            {options.map(option => (
              <option key={option.displayKey} value={option.displayKey}>
                {option.displayName}
              </option>
            ))}
          </select>
        )}
        <div className="ag-filter-body">
          <div className="ag-input-wrapper">
            <input
              className="ag-filter-filter"
              ref={ref => (this.input = ref)}
              value={this.state.filter}
              onChange={this.onChange}
            />
          </div>
        </div>
      </div>
    );
  }
}
